import { AudioLevelAnalyser } from '@yandex-360/telemost-sdk/audio-diagnostics';

import { getAudioContext } from '../../../../helpers/audio-context';

const audioContext = getAudioContext();
export const diagnosticAudioLevelAnalyser = audioContext ? new AudioLevelAnalyser(audioContext) : null;
